import { render, staticRenderFns } from "./FilesUpload.vue?vue&type=template&id=ee971518&"
import script from "./FilesUpload.vue?vue&type=script&lang=ts&"
export * from "./FilesUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports